<script>
import { infoDetailsMethods, deviceComputed, deviceMethods } from '@state/helpers'

import { statusHistoryCssBackgroundClass } from '@utils/design/status-css-classes'
import { cycleCssClass } from '@utils/design/cycle-css-classes'

export default {
  name: 'CDeviceStateInfo',

  props: {
    deviceStateHistory: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...deviceComputed,

    cycleCssClassComputed: function() {
      return cycleCssClass(this.cyclePercentageComputed)
    },

    statusHistoryCssBackgroundClass: function() {
      return statusHistoryCssBackgroundClass(this.deviceStateHistory.totalRunningMinutes)
    },
  },

  updated: function() {
    this.update()
  },

  mounted: function() {
    this.update()
  },

  methods: {
    ...infoDetailsMethods,
    ...deviceMethods,
  },
}
</script>

<template>
  <div>
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info mb-1 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 pl-3 mb-0  text-uppercase pt-3">
          <span class="">
            {{ deviceStateHistory.device.name }}
            <span
              >{{ deviceStateHistory.hour }}:00 -
              {{ deviceStateHistory.hour + 1 }}:00</span
            >
          </span>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info mb-3 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="sm4 h5 pl-3 mb-0  text-uppercase pt-1">
          <p class="text-uppercase  mb-0">
            <span class="text-success clearfix">RUNNING</span>
            {{ Math.round(deviceStateHistory.totalRunningMinutes)
            }}<span class="font-xs text-muted"> Mins</span>
          </p>
        </b-col>

        <b-col class=" sm4 h5 pl-3 mb-0  text-uppercase pt-1">
          <p class="text-uppercase  mb-0">
            <span class="text-warning clearfix">HOLD</span
            >{{ Math.round(deviceStateHistory.totalHoldMinutes) }}
            <span class="font-xs text-muted"> Mins</span>
          </p>
        </b-col>

        <b-col class="sm4 h5 pl-3 mb-0  text-uppercase pt-1">
          <p class="text-uppercase  mb-0">
            <span class="text-primary clearfix">IDLE</span
            >{{
              Math.round(
                60 -
                  deviceStateHistory.totalRunningMinutes -
                  deviceStateHistory.totalHoldMinutes
              )
            }}
            <span class="font-xs text-muted"> Mins</span>
          </p>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info  mb-0 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="sm-4  pl-3 mb-0  text-uppercase pt-2">
          <span class="w-100 font-weight-bold  btn-block text-muted">
            Average Rate
          </span>
        </b-col>
        <b-col class="sm-8 pl-0 mb-0 pt-0 text-uppercase device-average-rate">
          <p class="text-uppercase mb-0 text-muted">
            <span class="h2 text-success">100</span> %
          </p>
        </b-col>
      </b-row>
    </b-card-body>

    <b-tabs>
      <b-tab title="Cycle" active>
        <b-row v-if="deviceStateHistory" class="ml-0 mr-0 ">
          <b-col class=" h5 pl-0 pr-0 mb-0  text-uppercase pt-1">
            <b-card-body
              v-for="cycle in deviceStateHistory.deviceCycles"
              :key="cycle.id"
              class="animated fadeIn card info-card card-body device-card-body-info p-0 pb-3 mb-3 clearfix"
            >
              <div class="pl-3 pr-3 pt-1 pb-0">
                <b-progress
                  striped="striped"
                  :animated="true"
                  class="progress-xs my-1 mt-3"
                  variant="primary"
                  :value="0"
                />

                <div class="text-uppercase ">
                  <span class=" font-weight-bold ">
                    {{ cycle.name }}
                  </span>
                </div>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Activity">
        <b-row class="ml-0 mr-0 pl-0">
          <b-col class=" h5 pl-0 pr-0 mb-0  text-uppercase pt-1">
            <b-card-body
              v-for="activity in deviceStateHistory.deviceActivities"
              :key="activity.id"
              class="animated fadeIn card info-card card-body device-card-body-info p-0 pb-3 mb-3 clearfix"
            >
              <div class="text-uppercase h5 pb-0 pl-3 pr-3 pt-1 mb-0">
                <p class="mb-1"> {{ activity.name }}</p>
                <b-badge
                  class="mr-2"
                  :variant="activity.planned == true ? 'success' : 'danger'"
                >
                  Planned
                </b-badge>
                <b-badge
                  class="mr-2"
                  :variant="activity.available == true ? 'success' : 'danger'"
                  >Available
                </b-badge>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
.device-info {
  min-width: 145px;
  max-height: 65px;
  overflow: hidden;
}
.device-info-row {
  overflow: hidden;
}
.device-card-body-info {
  overflow: hidden;
  border-radius: 0 !important;
}
.device-average-rate {
  padding-top: 0.1rem !important;
}
.info-card {
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
}
.b-card-body:hover {
  z-index: 1;
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
::selection {
  background: #000; /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: #000; /* Gecko Browsers */
}
</style>
